import { AppHeader } from "components/layout/Header";
import { Banner } from "features/無料占いBot/components/Banner";
import SelectTheme from "features/無料占いBot/components/SelectTheme";
import {
  SelectAnswer,
  SelectBirthday,
  SelectBloodType,
  SelectPartnerBirthday,
  InputName,
  Result,
} from "features/無料占いBot/components/Sequences";
import { useFreeFortuneForm } from "features/無料占いBot/hooks/useFreeFortuneForm";
import useSubmitActions from "features/無料占いBot/hooks/useSubmitActions";
import { useState } from "react";
import { FormProvider } from "react-hook-form";
import { useFreeFortuneThemes } from "repositories/hooks";
import { ScrollMeasure } from "shared/components/atoms/ScrollMeasure";
import { Loading } from "shared/components/templates/Loading";
import { useClientRect } from "shared/hooks/useClientRect";
import { useDeviceInfo } from "shared/hooks/useDeviceInfo";
import { ResultType } from "shared/models/free_fortune_chat_question";
import { zIndex } from "shared/styles";
import { css } from "styled-components";
import tw from "twin.macro";

export const fortuneTellerIcon = `/icons/koko.svg`;

interface Props {
  resultType?: ResultType;
}

export const 無料占いBot = ({ resultType }: Props) => {
  const [bannerPosition, setBannerPosition] = useState<"relative" | "fixed">(
    "relative"
  );

  const { themes, isLoading } = useFreeFortuneThemes(resultType);
  const { form } = useFreeFortuneForm();

  const [
    themeValue,
    themeConfirmValue,
    answerConfirmValue,
    birthdayConfirmValue,
    bloodtypeConfirmValue,
    partnerBirthdayConfirmValue,
    nameConfirmValue,
  ] = form.watch([
    "theme",
    "themeConfirm",
    "answerConfirm",
    "birthdayConfirm",
    "bloodtypeConfirm",
    "partnerBirthdayConfirm",
    "nameConfirm",
  ]);

  const { dispatchSubmitAction } = useSubmitActions();
  const { deviceInfo } = useDeviceInfo();
  const { rect: headerRect, ref: headerRef } = useClientRect([]);

  const theme = themes.find((theme) => theme.id.toString() === themeValue);

  const isConfirmed = Number(true).toString();

  const onScroll = (
    clientHeight: number,
    innterHeight: number,
    scrollY: number,
    _timestamp: number
  ) => {
    if (scrollY >= headerRect?.height && bannerPosition === "relative") {
      setBannerPosition("fixed");
    } else if (scrollY < headerRect?.height && bannerPosition === "fixed") {
      setBannerPosition("relative");
    } else {
      // do nothing
    }
  };

  return (
    <ScrollMeasure onScroll={onScroll}>
      <div css={!deviceInfo?.device.isMobile && tw`max-w-md mx-auto`}>
        <Loading loading={isLoading} />
        <AppHeader
          ref={headerRef}
          disabled
          position="static"
          css={!deviceInfo?.device.isMobile && tw`max-w-md`}
        >
          <div tw="bg-gradient-theme-to-l w-[219px] h-6 rounded flex-center text-white font-semibold text-2xs">
            会員数60万人超の国内最大級の占いサイト ▶
          </div>
        </AppHeader>
        <Banner
          css={[
            css({ position: bannerPosition }),
            bannerPosition === "fixed" && [
              tw`top-0`,
              css({ zIndex: zIndex.fixed }),
              !deviceInfo?.device.isMobile && tw`max-w-md mx-auto`,
            ],
          ]}
        />
        <FormProvider {...form}>
          <form
            tw="px-5 pb-5"
            onSubmit={form.handleSubmit(dispatchSubmitAction)}
          >
            <SelectTheme themes={themes} />
            {themeConfirmValue == isConfirmed && (
              <SelectAnswer themes={themes} theme={theme} />
            )}
            {answerConfirmValue == isConfirmed && (
              <SelectBirthday themes={themes} theme={theme} />
            )}
            {birthdayConfirmValue == isConfirmed && <SelectBloodType />}
            {bloodtypeConfirmValue == isConfirmed && <SelectPartnerBirthday />}
            {partnerBirthdayConfirmValue == isConfirmed && (
              <InputName htmlNative />
            )}
            {nameConfirmValue == isConfirmed && <Result />}
          </form>
        </FormProvider>
      </div>
    </ScrollMeasure>
  );
};
